module.exports = __webpack_public_path__ + "img/4.5.1_Russian_road_sign.e0e76d81.svg";